import { MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { MenuPublishedState, MessageBarText, StationEditState } from "../../common/commonConstants";
import { notificationStateSelector } from "../../selectors/diningSelector";

export const MenuMessageBar = () => {
  const notificationState = useSelector(notificationStateSelector);
  return (
    <div>
      {notificationState === MenuPublishedState.LOADING ? (
        <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>
          {MessageBarText.LOADING}
        </MessageBar>
      ) : notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MessageBarText.CHANGES_PUBLISHED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.PUBLISHING_IN_PROGRESS ? (
        <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>
          {MessageBarText.PUBLISHING_IN_PROGRESS}
        </MessageBar>
      ) : notificationState === MenuPublishedState.DELETING_IN_PROGRESS ? (
        <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>
          {MessageBarText.DELETING_IN_PROGRESS}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_ADDED_TO_BANK_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MessageBarText.ITEM_ADDED_TO_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_REMOVE_FROM_BANK_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MessageBarText.ITEM_REMOVE_FROM_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === StationEditState.STATION_CREATED_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MessageBarText.STATION_CREATED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === StationEditState.STATION_DELETED_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MessageBarText.STATION_DELETED_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_SAVED_TO_MENU_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MenuPublishedState.ITEM_SAVED_TO_MENU_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.ITEM_EDITED_IN_BANK_SUCCESSFULLY ? (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {MenuPublishedState.ITEM_EDITED_IN_BANK_SUCCESSFULLY}
        </MessageBar>
      ) : notificationState === MenuPublishedState.UNPUBLISHED_CHANGES ? (
        <MessageBar messageBarType={MessageBarType.warning} isMultiline={false}>
          {MessageBarText.UNPUBLISHED_CHANGES}
        </MessageBar>
      ) : null}
    </div>
  );
};
